import React, { Component } from 'react';
import classNames from 'classnames';
import './Instructions.css';
import TrackEvent from '../event';

class Instructions extends Component {    
    constructor(props){
        super(props);

        this.toggleInstructions = this.toggleInstructions.bind(this);

        this.state = {
            active_instructions: "ios"
        }
    }

    toggleInstructions(instruction){
        this.setState({
            active_instructions: instruction
        })
    }
    
    render(){
        const ios_btn_classes = classNames(["btn col col-4 p2"], {active: this.state.active_instructions === "ios"})
        const android_btn_classes = classNames(["btn col col-4 p2"], {active: this.state.active_instructions === "android"})     
        const desktop_btn_classes = classNames("btn col col-4 p2", {active: this.state.active_instructions === "desktop"})
        // var instructions;

        if(this.state.active_instructions === "ios") {
            var instructions = <iPhoneInstructions />
            var downloadLink =  "disconnectme://link?code=" + this.props.code
        } else if(this.state.active_instructions === "desktop") {
            var instructions = "Desktop ones"
        }

        
        return (
            <div className="instructions col col-12 p2">
                <icon className="fa fa-close" onClick={this.props.hide} />                    

                <h1>Congratulations!</h1>
                <h2>Select device for installation instructions</h2>
                <div className="btns rounded col col-12 rounded overflow-hidden border">
                    <div className={ios_btn_classes} onClick={() => this.toggleInstructions("ios")}>
                        <icon className="fa fa-apple"></icon>
                        <span className="instruction-label">iOS</span>
                    </div>
                    <div className={android_btn_classes} onClick={() => this.toggleInstructions("android")}>
                        <icon className="fa fa-android"></icon>                        
                        <span className="instruction-label">Android</span>
                    </div>
                    <div className={desktop_btn_classes} onClick={() => this.toggleInstructions("desktop")}>
                        <icon className="fa fa-desktop"></icon>                        
                        <span className="instruction-label">Desktop</span>
                    </div>
                </div>
                { this.state.active_instructions === "ios" &&
                    <div className="col col-12 p0">
                        <hr />
                        <ol className="m0 pt3">
                            <li className="mb3">Download the app here: <a href="https://itunes.apple.com/app/id935480186">https://itunes.apple.com/app/id935480186</a></li>
                            <li className="my3">Enter this URL in your mobile browser: <a href={downloadLink}>{downloadLink}</a><br /><br />Or email this URL to yourself for easy access on your iOS device: <a href={"mailto:?subject=iOS-activation-code&body=Activation%20Code:" + this.props.code}>Send me my upgrade URL</a></li>
                        </ol>
                    </div>
                }

                { this.state.active_instructions === "android" &&
                    <div className="col col-12 p0">
                        <hr />                        
                        <ol className="m0 pt3">
                            <li className="mb3">Install our Android app here: <a href="https://disconnect.me/mobile/disconnect-mobile/sideload">https://disconnect.me/mobile/disconnect-mobile/sideload</a></li>
                            <li className="mb3">Click <strong>Upgrade to protect</strong></li>
                            <li className="mb3">Enter code <strong>{this.props.code}</strong> where indicated</li>
                        </ol>
                    </div>
                }

                { this.state.active_instructions === "desktop" &&
                    <div className="col col-12 p0">
                        <hr />                        
                        <ol className="m0 pt3">
                            <li className="mb3">Download the app - <a href="/premium/mac">Mac</a> or <a href="/premium/win">PC</a></li>
                            <li className="mb3">Click <strong>Premium Protection</strong></li>
                            <li className="mb3">Click <strong>Already have a code</strong></li>
                            <li className="mb3">Enter code <strong>{this.props.code}</strong> where indicated</li>
                        </ol>
                    </div>
                }
                
            </div>
        )
    }
}   

export default Instructions;



// WEBPACK FOOTER //
// ./src/instructions/index.js